import { get, post, patch } from '../../services/';
import routes from './routes';

const AuthServices = {
  
 
    authLogin: async (obj) => {
    const data = await post(routes.authLogin, obj);
    return data;
  },
  SendOtp: async (obj) => {
    const data = await post(routes.SendOtp, obj);
    return data;
  },
  authLoginViaEmail: async (obj) => {
    const data = await post(routes.authLoginViaEmail, obj);
    return data;
  },
  authRegisterViaEmail: async (obj) => {
    const data = await post(routes.authRegisterViaEmail, obj);
    return data;
  },
  generateSession: async (obj) => {
    const data = await post(routes.generateSession, obj);
    return data;
  },
  
}

export default AuthServices